export default __webpack_public_path__ + "static/blob-34-73723fcef1ceec1a4673ad34462b49bb.svg";